import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';

/**
 * Estado vazio padronizado. Antes havia blocos inline em Custos, Safras, Cargas
 * e mais nove parágrafos soltos com o mesmo estilo.
 *
 * Um bom estado vazio explica o que aconteceu e diz o próximo passo — por isso
 * `acao` existe: sem ela o usuário fica sabendo que está vazio mas não o que fazer.
 *
 * @param icone     chave do registro em `ui/Icon` (era um emoji cravado)
 * @param titulo    frase curta do que está vazio
 * @param descricao explicação e próximo passo
 * @param acao      { to, label } para navegar, ou { onClick, label } para agir
 * @param compacto  reduz o espaçamento, para uso dentro de abas
 */
export default function EmptyState({ icone = 'documento', titulo, descricao, acao, compacto }) {
  return (
    <div className={`empty-state ${compacto ? 'empty-state--compacto' : ''}`}>
      <div className="empty-state-icone" aria-hidden="true">
        <Icon nome={icone} tamanho={compacto ? 20 : 24} />
      </div>
      {titulo && <div className="empty-state-titulo">{titulo}</div>}
      {descricao && <div className="empty-state-desc">{descricao}</div>}
      {acao && (
        acao.to
          ? <Link to={acao.to} className="btn-primary empty-state-acao">{acao.label}</Link>
          : <button type="button" className="btn-primary empty-state-acao" onClick={acao.onClick}>{acao.label}</button>
      )}
    </div>
  );
}
